import './i18n'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ToastContainer } from 'react-toastify'

import { toastContainerSchema } from './@types/schemas/toast-containers'
import { SessionProvider } from './contexts/auth/session'
import { UserProvider } from './contexts/auth/user'
import { FeatureFlagsProvider } from './contexts/feature-flags/feature-flags-provider'
import { SentryUserProvider } from './contexts/sentry/sentry-user-provider'
import { ThemeProvider } from './contexts/theme'
import { queryClient } from './queries'
import { AppRoutes } from './routes/index'

export function App() {
  return (
    <>
      <ToastContainer containerId={toastContainerSchema.Enum.GLOBAL} />

      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <SessionProvider>
          <UserProvider>
            <FeatureFlagsProvider>
              <SentryUserProvider>
                <ThemeProvider defaultTheme="light" storageKey="@studio:theme">
                  <AppRoutes />
                </ThemeProvider>
              </SentryUserProvider>
            </FeatureFlagsProvider>
          </UserProvider>
        </SessionProvider>
      </QueryClientProvider>
    </>
  )
}
